exports.canContainEols = ['delete'];
exports.enter = {
  strikethrough: enterStrikethrough
};
exports.exit = {
  strikethrough: exitStrikethrough
};
function enterStrikethrough(token) {
  this.enter({
    type: 'delete',
    children: []
  }, token);
}
function exitStrikethrough(token) {
  this.exit(token);
}